var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-16 ml-6",attrs:{"id":"app","align":"center"}},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{attrs:{"src":require("../assets/InTheSuburbs-small.png"),"href":"/","max-width":"350","alt":"InTheSuburbs.com.au"}})],1),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('search')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }